import { Box, Typography, IconButton } from '@mui/material'
import DescriptionIcon from '@mui/icons-material/Description'
import DownloadIcon from '@mui/icons-material/Download'

interface DocumentPreviewProps {
  url: string
  variant: 'card' | 'chat'
}

export const DocumentPreview = ({ url, variant }: DocumentPreviewProps) => {
  const isChat = variant === 'chat'

  if (isChat) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
        }}
      >
        <DescriptionIcon sx={{ fontSize: 40, color: 'text.secondary', mb: 1 }} />
        <Typography variant="body2" color="text.secondary" mb={1}>
          Preview not available
        </Typography>
        <IconButton
          onClick={e => {
            e.stopPropagation()
            window.open(url, '_blank')
          }}
          sx={{ color: 'primary.main' }}
        >
          <DownloadIcon />
        </IconButton>
      </Box>
    )
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        textAlign: 'center',
      }}
    >
      <DescriptionIcon sx={{ fontSize: 64, color: 'text.secondary', mb: 2 }} />
      <Typography variant="h6" color="text.secondary" mb={1}>
        Preview not available
      </Typography>
      <Typography variant="body2" color="text.secondary" mb={2}>
        This file type cannot be previewed in the browser
      </Typography>
      <IconButton onClick={() => window.open(url, '_blank')} sx={{ color: 'primary.main' }}>
        <DownloadIcon />
      </IconButton>
    </Box>
  )
}
